import { Component } from '@angular/core';
import { NavbarComponent } from "../../../partials/navbar/navbar.component";
import { FooterComponent } from "../../../partials/footer/footer.component";
import { LanguageService } from '../../../services/language.service';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-tuv-sud',
  standalone: true,
  imports: [NavbarComponent, FooterComponent],
  templateUrl: './tuv-sud.component.html',
  styleUrl: './tuv-sud.component.css'
})
export class TuvSudComponent {
  texts: any;
    constructor(private langService:LanguageService, private title:Title){
      this.texts = this.langService.getWebisteTexts().tud_suv;
      
      this.title.setTitle('PRINX - TÜV SÜD Certification') 

    }
}
